// extracted by mini-css-extract-plugin
export default {"App":"main-module_App_PNneI","Main":"main-module_Main_iXT3U","Wrapper":"main-module_Wrapper_U3EuE"};